import Vue from 'vue'
import _ from 'lodash'
import Axios from 'axios'
import Store from './store'
import Router from 'vue-router'
import VueCookie from 'vue-cookie'
import Cons from '@/constants.json'
import VueAnalytics from 'vue-analytics'
import AuthComponent from '@/views/AuthComponent'
import MainComponent from '@/views/MainComponent'
import HomeComponent from '@/views/HomeComponent'
import MenuComponent from '@/views/MenuComponent'
import FeedComponent from '@/views/FeedComponent'
import Vash from '@/views/Vash'
import ProfileComponent from '@/views/ProfileComponent'
import ViewUserProfile from '@/views/ViewUserProfile'
import DoActionMenu from '@/views/DoActionMenu'
import FeedSingleComponent from '@/views/FeedSingleComponent'
import ResourcesSingleComponent from '@/views/ResourcesSingleComponent'
import ResourcesListComponent from '@/views/ResourcesListComponent'
import ViewPublicProfileComponent from '@/views/ViewPublicProfileComponent'
import NearbyListComponent from '@/views/NearbyListComponent'
import FeedSingleCommentComponent from '@/views/FeedSingleCommentComponent'
import ProfileInfoOthers from '@/views/ProfileInfoOthers'
import ContactUsSingleComponent from '@/views/ContactUsSingleComponent'
import AboutUsComponent from '@/views/AboutUsComponent'
import AboutUsSingleComponent from '@/views/AboutUsSingleComponent'
import PrivacyPolicyComponent from '@/views/PrivacyPolicyComponent'
import TermsAndConditionsComponent from '@/views/TermsAndConditionsComponent'
import ReportMissingComponent from '@/views/ReportMissingComponent'
import ReportAbuseComponent from '@/views/ReportAbuseComponent'
import PostUpdateComponent from '@/views/PostUpdateComponent'
import DirectoriesComponent from '@/views/DirectoriesComponent'
import FeedSingleReplyComponent from '@/views/FeedSingleReplyComponent'
import PendingInvitationsComponent from '@/views/PendingInvitationsComponent'
import PreviewComponent from '@/views/PreviewComponent'
import PreviewGetStarted from '@/views/PreviewGetStarted'
import VerificationMessage from '@/views/VerificationMessage'
import CreateGroupComponent from '@/views/CreateGroupComponent'
import FBAuthComponent from '@/views/FBAuthComponent'
import VideoComponent from '@/views/VideoComponent'
import LoginComponent from '@/views/LoginComponent'
import Onboarding from '@/views/onboarding/Onboarding'
import SetLocation from "@/views/SetLocationComponent"
import OnBoardingComponent from '@/views/OnBoardingComponent'
import SetLocationComponent from "@/views/SetLocationComponent"
import LikesComponent from '@/views/LikesComponent'
import CheckInComponent from "@/views/CheckInComponent"
import EmailConfirmationComponent from '@/views/EmailConfirmationComponent'
import CreateOrganization from '@/views/CreateOrganization'
import NotificationComponent from '@/views/NotificationComponent'
import ComingSoonComponent from '@/views/ComingSoonComponent'
import AdvocacyComponent from '@/views/AdvocacyComponent'
import ResourceByType from '@/views/ResourceByType'
import AlliancesComponent from '@/views/AlliancesComponent'
import DonateComponent from '@/views/DonateComponent'
import ShareComponent from '@/views/ShareComponent'
import EventsComponent from '@/views/EventsComponent'
import SpecialProjectsComponent from '@/views/SpecialProjectsComponent'
import ArtworkComponent from '@/views/ArtworkComponent'
import ResourceMenuComponent from '@/views/ResourceMenuComponent'
import ResourceMenuDiscoverComponent from '@/views/ResourceMenuDiscoverComponent'
import CallToActionComponent from '@/views/CallToActionComponent'
import FAQComponent from '@/views/FAQComponent'
import PasswordResetComponent from '@/views/PasswordResetComponent'
import ProfileSettings from '@/views/ProfileSettings'
import EmergencyHotline from '@/views/EmergencyHotline'
import VerifyMobile from '@/views/VerifyMobile'
import ExtrasComponent from '@/views/ExtrasComponent'
import StepOne from '@/views/StepOne'
import StepTwo from '@/views/StepTwo'
import StepThree from '@/views/StepThree'
import EventsPublicComponent from '@/views/EventsPublicComponent'
import PeopleComponent from '@/views/PeopleComponent'
import PeopleMenuComponent from '@/views/PeopleMenuComponent'
import SubMenuComponent from '@/components/SubMenuComponent'
import DocumentsHolder from '@/views/DocumentsHolder'
import LibraryComponent from '@/views/LibraryComponent'
import TrackComponent from '@/views/TrackComponent'
import AppSelector from '@/views/AppSelector'
import ModuleComponent from '@/views/ModuleComponent'
import OrganizationComponent from '@/views/OrganizationComponent'
import OrganizationListing from '@/views/OrganizationList'
import CareTeamList from '@/views/CareTeamList'
import OnboardingPass from '@/views/OnboardingPass'
import OrganizationList from '@/views/OrganizationList'
import Welcome from '@/views/welcome/Welcome'

Vue.use(Router);

window.reRoute = (url) => {
	router.push(url)
}

const APPCOOKIE = `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}COOKIE`;

const setAuthHeaders = () => {
	if (localStorage.getItem(APPCOOKIE)) {
		let mCookie = localStorage.getItem(APPCOOKIE)
		let uCookie = JSON.parse(mCookie)

		Axios.defaults.headers.common['Authorization'] = null
		Axios.defaults.headers.common['Authorization'] = 'Bearer ' + uCookie.access_token
		Axios.defaults.headers.put['Content-Type'] = 'application/json'
		Axios.defaults.headers.post['Content-Type'] = 'application/json'
		Axios.defaults.headers.get['Cookie'] = '';
		Axios.defaults.headers.put['Cookie'] = '';
		Axios.defaults.headers.post['Cookie'] = '';
		Axios.defaults.headers.delete['Cookie'] = '';
	}
}

const capitalizeFirstLetter = (string) => {
	return string[0].toUpperCase() + string.slice(1);
}

const setTabTitle = (mdl) => {
	document.title = ('title' in mdl) ? mdl.title : ''
}

const beforeEnterMethod = (to, from, next) => {
	setAuthHeaders()
	next()
}

const setMetaObj = (title, isVisibleBack, hideToolBar, auth, mobileMain, isAllowGuest) => {
	let metaD = {
		title: title || '',
		isVisibleBack: isVisibleBack || 0,
		hideToolBar: hideToolBar || 0,
		auth: auth || 0
	}
	if (mobileMain) metaD.mobileMain = mobileMain || 0
	if (isAllowGuest) metaD.isAllowGuest = isAllowGuest || 0
	return metaD
}

const rootChildren = [
	{
        path: 'app-selector',
        name: 'app-selector-ui',
        component: AppSelector,
		    meta: setMetaObj('Choose App', 1, 1, 1, 0, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'track/:trackId',
        name: 'TrackComponent',
        component: TrackComponent,
		meta: setMetaObj('Track', 1, 0, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'module/:moduleId',
        name: 'ModuleComponent',
        component: ModuleComponent,
		meta: setMetaObj('Module', 1, 0, 1, null, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'calltoaction',
        name: 'CallToActionComponent',
        component: CallToActionComponent,
		meta: setMetaObj('Call to action', 0, 0, 1, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'donate',
        name: 'DonateComponent',
        component: DonateComponent,
		meta: setMetaObj('Donate', 1, 0, 0, null, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'organization',
        name: 'AlliancesComponent',
        component: AlliancesComponent,
		meta: setMetaObj('Organizations', 1, 0, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'organization/:orgId',
        name: 'OrganizationComponent',
        component: OrganizationComponent,
		meta: setMetaObj('Organizations', 1, 0, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'organization-list',
        name: 'OrganizationList',
        component: OrganizationList,
		meta: setMetaObj('Organizations', 1, 0, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'group-type/:groupType',
        name: 'GroupTypes',
        component: ResourceByType,
		meta: setMetaObj('Groups', 1, 0, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'advocacies',
        name: 'AdvocacyComponent',
        component: AdvocacyComponent,
		meta: setMetaObj('Advocacies', 1, 1, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'eventsPublic',
        name: 'EventsPublic',
        component: EventsPublicComponent,
		meta: setMetaObj('Events', 1, 0, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'notifications',
        name: 'NotificationComponent',
        component: NotificationComponent,
		meta: setMetaObj('Notifications', 1, 1, 0, null, null)
	}, {
        path: 'coming-soon',
        name: 'ComingSoonComponent',
        component: ComingSoonComponent,
		meta: setMetaObj('Coming Soon', 1, 1, 0, null, null)
	}, {
        path: 'create-organization',
        name: 'CreateOrganization',
        component: CreateOrganization,
		meta: setMetaObj('Register Organization', 1, 1, 0, null, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'share',
        name: 'Share',
        component: ShareComponent,
		meta: setMetaObj('Invite others to join', 1, 1, 0, null, null)
	}, {
        path: 'report-abuse',
        name: 'ReportAbuse',
        component: ReportAbuseComponent,
		meta: setMetaObj('Report Abuse', 1, 0, 0, null, null)
	}, {
        path: 'library',
        name: 'Library',
        component: LibraryComponent,
		meta: setMetaObj('Discover', 1, 0, 0, 2, null),
        beforeEnter: (to, from, next) => {
			setAuthHeaders()
			if( to.params.uid === Cons[0].GUEST) {
				Store.commit('hitCheckpoint')
				return false
			}
			next()
        }
	}, {
        path: 'report-missing',
        name: 'ReportMissing',
        component: ReportMissingComponent,
		meta: setMetaObj('Report Missing', 1, 0, 0, null, null)
	}, {
        path: 'onboarding',
        name: 'OnBoarding',
		component: Onboarding,
		meta: setMetaObj('Onboarding', 0, 1, 1, null, 0),
        beforeEnter: (to, from, next) => {
			setAuthHeaders()
			setTimeout(() => {
				if ( Store.state.user.info.user_type === 'guest')
					next('/')
				else
					next()
			}, 1000)
        }
	}, {
        path: 'terms-and-conditions',
        name: 'TermsAndConditions',
        component: TermsAndConditionsComponent,
		meta: setMetaObj('Terms & Conditions', 1, 0, 0, null, null)
	}, {
        path: 'privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicyComponent,
		meta: setMetaObj('Privacy Policy', 1, 0, 0, null, null)
	}, {
        path: 'forgot-password',
        name: 'PasswordResetComponent',
        component: PasswordResetComponent,
		meta: setMetaObj('Forgot Password', 1, 1, 0, null, null)
	}, {
        path: 'about-us',
        name: 'AboutUs',
        component: AboutUsComponent,
		meta: setMetaObj('About Us', 1, 0, 0, null, null)
	}, {
        path: 'documents',
        name: 'documents',
        component: DocumentsHolder,
		meta: setMetaObj('My Documents', 1, 0, 0, null, null)
	}, {
        path: 'about-us-s',
        name: 'AboutUsSingle',
        component: AboutUsSingleComponent,
		meta: setMetaObj('About Us', 1, 1, 0, null, null)
	}, {
        path: 'contact-us-s',
        name: 'ContactUs',
        component: ContactUsSingleComponent,
		meta: setMetaObj('Contact Us', 1, 1, 0, null, null)
	}, {
        path: 'verify',
        name: 'VerifyMobileComponent',
        component: VerifyMobile,
		meta: setMetaObj('Verification', 0, 1, 1, null, null)
	}, {
        path: 'step1',
        name: 'StepOneMobileComponent',
        component: StepOne,
		meta: setMetaObj('Welcome', 0, 1, 1, null, null)
	}, {
        path: 'step2',
        name: 'StepTwoMobileComponent',
        component: StepTwo,
		meta: setMetaObj('Welcome', 0, 1, 1, null, null)
	}, {
        path: 'step3',
        name: 'StepThreeMobileComponent',
        component: StepThree,
		meta: setMetaObj('Welcome', 0, 1, 1, null, null)
	}, {
        path: 'login',
        name: 'LoginComponent',
        component: LoginComponent,
		meta: setMetaObj('Login', 0, 1, 1, null, 1),
        beforeEnter: (to, from, next) => {
			setAuthHeaders()
			if ( _.get(to, 'query.type') === 'signup' ) 
				to.meta.title = 'Register'
			else 
				to.meta.title = 'Login'
			next()
        }
	}, {
        path: 'home',
        name: 'HomePage',
        component: HomeComponent,
		meta: setMetaObj('Home', null, 0, 1, 0, 1),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'verification-message',
        name: 'VerificationMessage',
        component: VerificationMessage,
		meta: setMetaObj('Verification', 0, 0, 0, 0, 1),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'feed',
        name: 'FeedPage',
        component: FeedComponent,
		meta: setMetaObj('News', 0, 0, 1, 7, 1),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'feed/:activityID',
        name: 'FeedSinglePage',
        component: FeedSingleComponent,
		meta: setMetaObj('', 1, 0, 1, null, 1),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'feed/:index/reply',
        name: 'FeedSingleReply',
        component: FeedSingleReplyComponent,
		meta: setMetaObj('Reply', 1, 1, 1, null, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'feed/:index/likes/:indexReply',
        name: 'Likes',
        component: LikesComponent,
		meta: setMetaObj('Likes', 1, 1, 1, null, null)
	}, {
        path: 'feed/:activityID/comments',
        name: 'FeedCommentPage',
        component: FeedSingleCommentComponent,
		meta: setMetaObj('Comments', 1, 1, 1, null, null),
        beforeEnter: (to, from, next) => {
			setAuthHeaders()
			Store.dispatch('feed/getFeedSingleItemActivities', to.params.activityID)
			next()
        }
	}, {
        path: 'nearby',
        name: 'NearbyPage',
        component: NearbyListComponent,
		meta: setMetaObj('Nearby', 1, 0, 1, null, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'people',
        name: 'PeopleComponent',
        component: PeopleComponent,
		meta: setMetaObj('People', 1, 0, 1, null, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'people-menu',
        name: 'PeopleMenuComponent',
        component: PeopleMenuComponent,
		meta: setMetaObj('People', 1, 0, 1, null, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'profile/:uid/view',
        name: 'ProfilePageView',
        component: ViewUserProfile,
        meta: setMetaObj('Profile', 1, 0, 1, 3, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'profile',
        name: 'ProfilePage',
        component: ProfileComponent,
        meta: setMetaObj('Profile', 0, 0, 1, 3, null),
        beforeEnter: (to, from, next) => {
			setAuthHeaders()
			if (_.isEmpty(Store.state.user.userFields)) Store.dispatch('user/getUserFields')
			if (_.isEmpty(Store.state.user.userBookmarks)) Store.dispatch('user/getUserBookmarks')
			next()
        }
	}, {
        path: 'others',
        name: 'ProfilePageOther',
        component: ProfileInfoOthers,
        meta: setMetaObj('Others', 1, 0, 1, 3, null),
        beforeEnter: (to, from, next) => {
			setAuthHeaders()
			if (_.isEmpty(Store.state.user.userFields)) { Store.dispatch('user/getUserFields') }
			next()
        }
	}, {
        path: 'profile/:uid',
        name: 'ProfileViewPage',
        component: ViewPublicProfileComponent,
        meta: setMetaObj('Profile View', 1, 0, 1, 3, null),
        beforeEnter: (to, from, next) => {
          	setAuthHeaders()
          	if( to.params.uid === Cons[0].GUEST) {
				Store.commit('hitCheckpoint')
				Store.commit('setCurrentTab', 10, {root:1})
            	return false
       	 	}
          	next()
        }
	}, {
        path: 'do-action',
        name: 'DoActionPage',
        component: DoActionMenu,
        meta: setMetaObj('Do Something', 0, 0, 1, 2, null)
	}, {
        path: 'resources/list',
        name: 'ResourceListPage',
        component: ResourcesListComponent,
        meta: setMetaObj('Groups', 1, 0, 1, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'resources/:planID',
        name: 'ResourceSinglePage',
        component: ResourcesSingleComponent,
        meta: setMetaObj('Groups', 1, 0, 1, null, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'resource',
        name: 'ResourceMenu',
        component: ResourceMenuComponent,
        meta: setMetaObj('Extras', 0, 0, 1, 4, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'groups',
        name: 'Groups',
        component: ResourceMenuDiscoverComponent,
        meta: setMetaObj('Connect', 0, 0, 1, 4, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'submenu/:groupId',
        name: 'SubMenu',
        component: SubMenuComponent,
        meta: setMetaObj('People', 1, 0, 1, 1, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'menu',
        name: 'MenuPage',
        component: MenuComponent,
        meta: setMetaObj('Menu', 0, 1, 1, 4, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'invitations',
        name: 'Invitations',
        component: PendingInvitationsComponent,
        meta: setMetaObj('Invitations', 1, 1, 1, 0, null)
	}, {
        path: 'directory',
        name: 'Directories',
        component: DirectoriesComponent,
        meta: setMetaObj('Directory', 1, 1, 1, 4, null),
		beforeEnter: (to, from, next) => {
			setAuthHeaders()
			to.meta.title = to.query.slug.replace(/_/g, ' ')
			next()
        }
	}, {
        path: 'post-update/:cid',
        name: 'PostUpdatePage',
        component: PostUpdateComponent,
        meta: setMetaObj('Post Update', 0, 1, 1, null, null),
		beforeEnter: (to, from, next) => {
			setAuthHeaders()
			Store.dispatch('feed/getCareplanInfo', to.params.cid)
				.then(res => {
					Store.commit('menu/setPostSelectionModal', false)
					Store.commit('publicModule/setShowPostItemModal', true)
				})
			next()
        }
	}, {
        path: 'videos',
        name: 'VideoComponent',
        component: VideoComponent,
        meta: setMetaObj('Videos', 1, 0, 1, 4, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'faq',
        name: 'FAQComponent',
        component: FAQComponent,
        meta: setMetaObj('Frequently Asked Questions', 1, 0, 0, 4, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'create-group',
        name: 'CreateGroup',
        component: CreateGroupComponent,
        meta: setMetaObj('Create Group', 1, 1, 1, null, null)
	}, {
        path: 'set-location',
        name: 'Set Location',
        component: SetLocationComponent,
        meta: setMetaObj('Set Location', 1, 1, 1, null, null)
	}, {
        path: 'check-in',
        name: 'Check In',
        component: CheckInComponent,
        meta: setMetaObj('Check In', 1, 1, 1, null, null)
	}, {
        path: 'events',
        name: 'Events',
        component: EventsComponent,
        meta: setMetaObj('Events', 1, 0, 0, 4, null),
        beforeEnter: (to, from, next) => {
			setAuthHeaders()
			Store.dispatch('events/getAllEvents', 1)
			next()
        }
	}, {
        path: 'special-projects',
        name: 'Specail Projects',
        component: SpecialProjectsComponent,
        meta: setMetaObj('Special Projects', 1, 0, 0, 4, null)
	}, {
        path: 'artwork',
        name: 'Artwork',
        component: ArtworkComponent,
		meta: setMetaObj('Artwork', 1, 0, 0, 4, null) 
	}, {
        path: 'settings',
        name: 'Settings',
        component: ProfileSettings,
		meta: setMetaObj('Profile Info', 1, 1, 0, 3, null) 
	}, {
        path: 'hotline',
        name: 'EmergencyHotline',
        component: EmergencyHotline,
		meta: setMetaObj('Emergency Hotline', 1, 0, 0, 0, null) 
	}, {
        path: 'extras/:id',
		name: 'Extras',
		component: ExtrasComponent,
		meta: setMetaObj('Extras', 1, 0, 0, 4, null)
	}
];

const brandSlugChildren = [
	{
        path: 'app-selector',
        name: 'app-selector-ui-Brand',
        component: AppSelector,
		    meta: setMetaObj('Choose App', 1, 1, 1, 0, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'track/:trackId',
        name: 'TrackComponent-Brand',
        component: TrackComponent,
		meta: setMetaObj('Track', 1, 0, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'module/:moduleId',
        name: 'ModuleComponent-Brand',
        component: ModuleComponent,
		meta: setMetaObj('Module', 1, 0, 1, null, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'calltoaction',
        name: 'CallToActionComponent-Brand',
        component: CallToActionComponent,
		meta: setMetaObj('Call to action', 0, 0, 1, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'donate',
        name: 'DonateComponent-Brand',
        component: DonateComponent,
		meta: setMetaObj('Donate', 1, 0, 0, null, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'organization',
        name: 'AlliancesComponent-Brand',
        component: AlliancesComponent,
		meta: setMetaObj('Organizations', 1, 0, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'organization/:orgId',
        name: 'OrganizationComponent-Brand',
        component: OrganizationComponent,
		meta: setMetaObj('Organizations', 1, 0, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'organization-list',
        name: 'OrganizationList-Brand',
        component: OrganizationList,
		meta: setMetaObj('Organizations', 1, 0, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'group-type/:groupType',
        name: 'GroupTypes-Brand',
        component: ResourceByType,
		meta: setMetaObj('Groups', 1, 0, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'advocacies',
        name: 'AdvocacyComponent-Brand',
        component: AdvocacyComponent,
		meta: setMetaObj('Advocacies', 1, 1, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'eventsPublic',
        name: 'EventsPublic-Brand',
        component: EventsPublicComponent,
		meta: setMetaObj('Events', 1, 0, 0, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'notifications',
        name: 'NotificationComponent-Brand',
        component: NotificationComponent,
		meta: setMetaObj('Notifications', 1, 1, 0, null, null)
	}, {
        path: 'coming-soon',
        name: 'ComingSoonComponent-Brand',
        component: ComingSoonComponent,
		meta: setMetaObj('Coming Soon', 1, 1, 0, null, 1)
	}, {
        path: 'create-organization',
        name: 'CreateOrganization-Brand',
        component: CreateOrganization,
		meta: setMetaObj('Register Organization', 1, 1, 0, null, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'share',
        name: 'Share-Brand',
        component: ShareComponent,
		meta: setMetaObj('Invite others to join', 1, 1, 0, null, null)
	}, {
        path: 'report-abuse',
        name: 'ReportAbuse-Brand',
        component: ReportAbuseComponent,
		meta: setMetaObj('Report Abuse', 1, 0, 0, null, null)
	}, {
        path: 'library',
        name: 'Library-Brand',
        component: LibraryComponent,
		meta: setMetaObj('Discover', 1, 0, 0, 2, null),
        beforeEnter: (to, from, next) => {
			setAuthHeaders()
			if( to.params.uid === Cons[0].GUEST) {
				Store.commit('hitCheckpoint')
				return false
			}
			next()
        }
	}, {
        path: 'report-missing',
        name: 'ReportMissing-Brand',
        component: ReportMissingComponent,
		meta: setMetaObj('Report Missing', 1, 0, 0, null, null)
	}, {
        path: 'onboarding',
        name: 'OnBoarding-Brand',
        component: Onboarding,
		meta: setMetaObj('Onboarding', 0, 1, 1, null, 0),
        beforeEnter: (to, from, next) => {
			setAuthHeaders()
			setTimeout(() => {
				if ( Store.state.user.info.user_type === 'guest')
					next(`/${to.params.brandSlug}/`)
				else
					next()
			}, 1000)
        }
	}, {
        path: 'terms-and-conditions',
        name: 'TermsAndConditions-Brand',
        component: TermsAndConditionsComponent,
		meta: setMetaObj('Terms & Conditions', 1, 0, 0, null, null)
	}, {
        path: 'privacy-policy',
        name: 'PrivacyPolicy-Brand',
        component: PrivacyPolicyComponent,
		meta: setMetaObj('Privacy Policy', 1, 0, 0, null, null)
	}, {
        path: 'forgot-password',
        name: 'PasswordResetComponent-Brand',
        component: PasswordResetComponent,
		meta: setMetaObj('Forgot Password', 1, 1, 0, null, null)
	}, {
        path: 'about-us',
        name: 'AboutUs-Brand',
        component: AboutUsComponent,
		meta: setMetaObj('About Us', 1, 0, 0, null, null)
	}, {
        path: 'documents',
        name: 'documents-Brand',
        component: DocumentsHolder,
		meta: setMetaObj('My Documents', 1, 0, 0, null, null)
	}, {
        path: 'about-us-s',
        name: 'AboutUsSingle-Brand',
        component: AboutUsSingleComponent,
		meta: setMetaObj('About Us', 1, 1, 0, null, null)
	}, {
        path: 'contact-us-s',
        name: 'ContactUs-Brand',
        component: ContactUsSingleComponent,
		meta: setMetaObj('Contact Us', 1, 1, 0, null, null)
	}, {
        path: 'verify',
        name: 'VerifyMobileComponent-Brand',
        component: VerifyMobile,
		meta: setMetaObj('Verification', 0, 1, 1, null, null)
	}, {
        path: 'step1',
        name: 'StepOneMobileComponent-Brand',
        component: StepOne,
		meta: setMetaObj('Welcome', 0, 1, 1, null, null)
	}, {
        path: 'step2',
        name: 'StepTwoMobileComponent-Brand',
        component: StepTwo,
		meta: setMetaObj('Welcome', 0, 1, 1, null, null)
	}, {
        path: 'step3',
        name: 'StepThreeMobileComponent-Brand',
        component: StepThree,
		meta: setMetaObj('Welcome', 0, 1, 1, null, null)
	}, {
        path: 'login',
        name: 'LoginComponent-Brand',
        component: LoginComponent,
		meta: setMetaObj('Login', 0, 1, 1, null, 1),
		beforeEnter: (to, from, next) => {
			setAuthHeaders()
			if ( _.get(to, 'query.type') === 'signup' ) 
				to.meta.title = 'Register'
			else 
				to.meta.title = 'Login'
			next()
        }
	}, {
        path: 'home',
        name: 'HomePage-Brand',
        component: HomeComponent,
		meta: setMetaObj('Home', null, 0, 1, 0, 1),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'verification-message',
        name: 'VerificationMessage-Brand',
        component: VerificationMessage,
		meta: setMetaObj('Verification', 0, 0, 0, 0, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'feed',
        name: 'FeedPage-Brand',
        component: FeedComponent,
		meta: setMetaObj('News', 0, 0, 1, 7, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'feed/:activityID',
        name: 'FeedSinglePage-Brand',
        component: FeedSingleComponent,
		meta: setMetaObj('', 1, 0, 1, null, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'feed/:index/reply',
        name: 'FeedSingleReply-Brand',
        component: FeedSingleReplyComponent,
		meta: setMetaObj('Reply', 1, 1, 1, null, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'feed/:index/likes/:indexReply',
        name: 'Likes-Brand',
        component: LikesComponent,
		meta: setMetaObj('Likes', 1, 1, 1, null, null)
	}, {
        path: 'feed/:activityID/comments',
        name: 'FeedCommentPage-Brand',
        component: FeedSingleCommentComponent,
		meta: setMetaObj('Comments', 1, 1, 1, null, null),
        beforeEnter: (to, from, next) => {
			setAuthHeaders()
			Store.dispatch('feed/getFeedSingleItemActivities', to.params.activityID)
			next()
        }
	}, {
        path: 'nearby',
        name: 'NearbyPage-Brand',
        component: NearbyListComponent,
		meta: setMetaObj('Nearby', 1, 0, 1, null, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'people',
        name: 'PeopleComponent-Brand',
        component: PeopleComponent,
		meta: setMetaObj('People', 1, 0, 1, null, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'people-menu',
        name: 'PeopleMenuComponent-Brand',
        component: PeopleMenuComponent,
		meta: setMetaObj('People', 1, 0, 1, null, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'profile/:uid/view',
        name: 'ProfilePageView-Brand',
        component: ViewUserProfile,
        meta: setMetaObj('Profile', 1, 0, 1, 3, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'profile',
        name: 'ProfilePage-Brand',
        component: ProfileComponent,
        meta: setMetaObj('Profile', 0, 0, 1, 3, null),
        beforeEnter: (to, from, next) => {
			setAuthHeaders()
			if (_.isEmpty(Store.state.user.userFields)) Store.dispatch('user/getUserFields')
			if (_.isEmpty(Store.state.user.userBookmarks)) Store.dispatch('user/getUserBookmarks')
			next()
        }
	}, {
        path: 'others',
        name: 'ProfilePageOther-Brand',
        component: ProfileInfoOthers,
        meta: setMetaObj('Others', 1, 0, 1, 3, null),
        beforeEnter: (to, from, next) => {
			setAuthHeaders()
			if (_.isEmpty(Store.state.user.userFields)) { Store.dispatch('user/getUserFields') }
			next()
        }
	}, {
        path: 'profile/:uid',
        name: 'ProfileViewPage-Brand',
        component: ViewPublicProfileComponent,
        meta: setMetaObj('Profile View', 1, 0, 1, 3, null),
        beforeEnter: (to, from, next) => {
          	setAuthHeaders()
          	if( to.params.uid === Cons[0].GUEST) {
				Store.commit('hitCheckpoint')
				Store.commit('setCurrentTab', 10, {root:1})
            	return false
       	 	}
          	next()
        }
	}, {
        path: 'do-action',
        name: 'DoActionPage-Brand',
        component: DoActionMenu,
        meta: setMetaObj('Do Something', 0, 0, 1, 2, null)
	}, {
        path: 'resources/list',
        name: 'ResourceListPage-Brand',
        component: ResourcesListComponent,
        meta: setMetaObj('Groups', 1, 0, 1, 1, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'resources/:planID',
        name: 'ResourceSinglePage-Brand',
        component: ResourcesSingleComponent,
        meta: setMetaObj('Groups', 1, 0, 1, null, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'resource',
        name: 'ResourceMenu-Brand',
        component: ResourceMenuComponent,
        meta: setMetaObj('Extras', 0, 0, 1, 4, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'groups',
        name: 'Groups-Brand',
        component: ResourceMenuDiscoverComponent,
        meta: setMetaObj('Connect', 0, 0, 1, 4, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'submenu/:groupId',
        name: 'SubMenu-Brand',
        component: SubMenuComponent,
        meta: setMetaObj('Sub Menu', 1, 0, 1, 1, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'menu',
        name: 'MenuPage-Brand',
        component: MenuComponent,
        meta: setMetaObj('Menu', 0, 1, 1, 4, null),
		beforeEnter: beforeEnterMethod
	}, {
        path: 'invitations',
        name: 'Invitations-Brand',
        component: PendingInvitationsComponent,
        meta: setMetaObj('Invitations', 1, 1, 1, 0, null)
	}, {
        path: 'directory',
        name: 'Directories-Brand',
        component: DirectoriesComponent,
        meta: setMetaObj('Directory', 1, 1, 1, 4, null),
		beforeEnter: (to, from, next) => {
			setAuthHeaders()
			to.meta.title = to.query.slug.replace(/_/g, ' ')
			next()
        }
	}, {
        path: 'post-update/:cid',
        name: 'PostUpdatePage-Brand',
        component: PostUpdateComponent,
        meta: setMetaObj('Post Update', 0, 1, 1, null, null),
		beforeEnter: (to, from, next) => {
			setAuthHeaders()
			Store.dispatch('feed/getCareplanInfo', to.params.cid)
				.then(res => {
					Store.commit('menu/setPostSelectionModal', false)
					Store.commit('publicModule/setShowPostItemModal', true)
				})
			next()
        }
	}, {
        path: 'videos',
        name: 'VideoComponent-Brand',
        component: VideoComponent,
        meta: setMetaObj('Videos', 1, 0, 1, 4, null),
		    beforeEnter: beforeEnterMethod
	}, {
        path: 'faq',
        name: 'FAQComponent-Brand',
        component: FAQComponent,
        meta: setMetaObj('Frequently Asked Questions', 1, 0, 0, 4, null),
        beforeEnter: beforeEnterMethod
	}, {
        path: 'create-group',
        name: 'CreateGroup-Brand',
        component: CreateGroupComponent,
        meta: setMetaObj('Create Group', 1, 1, 1, null, null)
	}, {
        path: 'set-location',
        name: 'Set Location-Brand',
        component: SetLocationComponent,
        meta: setMetaObj('Set Location', 1, 1, 1, null, null)
	}, {
        path: 'check-in',
        name: 'Check In-Brand',
        component: CheckInComponent,
        meta: setMetaObj('Check In', 1, 1, 1, null, null)
	}, {
        path: 'events',
        name: 'Events-Brand',
        component: EventsComponent,
        meta: setMetaObj('Events', 1, 0, 0, 4, null),
        beforeEnter: (to, from, next) => {
          setAuthHeaders()
          Store.dispatch('events/getAllEvents', 1)
          next()
        }
	}, {
        path: 'special-projects',
        name: 'Specail Projects-Brand',
        component: SpecialProjectsComponent,
        meta: setMetaObj('Special Projects', 1, 0, 0, 4, null)
	}, {
        path: 'artwork',
        name: 'Artwork-Brand',
        component: ArtworkComponent,
		    meta: setMetaObj('Artwork', 1, 0, 0, 4, null) 
	}, {
        path: 'settings',
        name: 'Settings-Brand',
        component: ProfileSettings,
		    meta: setMetaObj('Profile Info', 1, 1, 0, 3, null) 
	}, {
        path: 'hotline',
        name: 'EmergencyHotline-Brand',
        component: EmergencyHotline,
		    meta: setMetaObj('Emergency Hotline', 1, 0, 0, 0, null) 
	}, {
        path: 'extras/:id',
        name: 'Extras-Brand',
        component: ExtrasComponent,
        meta: setMetaObj('Extras', 1, 0, 0, 4, null)
	}
];

const router = new Router({
	mode: 'history',
	scrollBehavior (to, from, savedPosition) {
		let position = { x: 0, y: 0 }
		if (savedPosition) position = savedPosition
		return new Promise((resolve, reject) => {
			setTimeout(() => resolve(position), 600)
		})
	},
	routes: [{
		path: '/',
		name: 'WelcomePage',
		component: MainComponent,
		redirect: `/${process.env.VUE_APP_DEV_ECOSYSTEM}/login`,
		meta: setMetaObj('Welcome', 0, 1, 0, null, 1),
		children: rootChildren
	}, {
		path: '/sign/',
		name: 'AuthenticationPage',
		component: AuthComponent,
		meta: setMetaObj('Sign In', 0, 1, 0, null, null)
	}, {
		path: '/vash/:token/',
		name: 'Validation',
		component: Vash,
		meta: setMetaObj('Validation', 0, 1, 0, null, 1)
	}, {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome,
    meta: setMetaObj('Welcome', 0, 1, 0, null, 1)
  }, {
		path: '/preview/',
		name: 'Preview',
		component: PreviewComponent,
		meta: setMetaObj('Preview', 0, 0, 0, null, 1)
	}, {
		path: '/:brandSlug/get-started/',
		name: 'Get Started',
		component: PreviewGetStarted,
		meta: setMetaObj('Get Started', 0, 0, 0, null, 1)
	}, {
		path: '/confirmation/',
		name: 'EmailConfirmation',
		component: EmailConfirmationComponent,
		meta: setMetaObj('Confirmation', 0, 0, 0, null, 1)
	}, {	
		path: '/fb/',
		name: 'Facebook Authentication',
		component: FBAuthComponent,
		meta: setMetaObj('Facebook', 0, 0, 0, null, null)
	}, {
		path: '/signout/',
		beforeEnter: () => {
			Store.dispatch('base/signout', null, {root: 1})
				.then( () => {
					next();
				})
		}
	}, {
		path: '/:brandSlug/',
		name: 'WelcomePage-Brand',
		component: MainComponent,
		meta: setMetaObj('Welcome', 0, 1, 0, null, 1),
		redirect: '/:brandSlug/login',
		children: brandSlugChildren
	}, {
		path: '/sign/',
		name: 'Brand AuthenticationPage',
		component: AuthComponent,
		meta: setMetaObj('Sign In', 0, 1, 0, null, null)
	}, {
		path: '/vash/:token/',
		name: 'Brand Validation',
		component: Vash,
		meta: setMetaObj('Validation', 0, 1, 0, null, 1)
	}, {
    path: '/:brandSlug/welcome',
    name: 'Welcome Brand',
    component: Welcome,
    meta: setMetaObj('Welcome', 0, 1, 0, null, 1)
  }, {
		path: '/:brandSlug/preview/',
		name: 'Brand Preview',
		component: PreviewComponent,
		meta: setMetaObj('Preview', 0, 0, 0, null, 1)
	}, {
		path: '/:brandSlug/get-started/',
		name: 'Brand Get Started',
		component: PreviewGetStarted,
		meta: setMetaObj('Get Started', 0, 0, 0, null, 1)
	}, {
		path: '/confirmation/',
		name: 'Brand EmailConfirmation',
		component: EmailConfirmationComponent,
		meta: setMetaObj('Confirmation', 0, 0, 0, null, 1)
	}, {
		path: '/fb/',
		name: 'Brand Facebook Authentication',
		component: FBAuthComponent,
		meta: setMetaObj('Facebook', 0, 0, 0, null, null)
	}, {
		path: '/signout/',
		beforeEnter: (to, from, next) => {
			Store.dispatch('base/signout', null, {root: 1})
				.then( () => {
					next();
				})
		}
	}]
});

router.beforeEach((to, from, next) => {
	setAuthHeaders()
	
	if (to.params && !('brandSlug' in to.params) && from.params.brandSlug){
		next({
			path: `/${from.params.brandSlug}${to.path}`,
			query: to.query
		})
		return false
	}

	if ( (to.name === 'LoginComponent-Brand' || to.name === 'LoginComponent') && localStorage.getItem(APPCOOKIE)) {
		let tabName = null, prescription = null;

		if ('ptype' in to.query && to.query.ptype) 
			tabName = to.query.ptype
		if ('prescription' in to.query && to.query.prescription) 
			prescription = to.query.prescription
	
		if (prescription && tabName === 'group') {
			VueCookie.set(
				`${Cons[0].PATHS.NAME}PLAN_PRESCRIPTION`,
				JSON.stringify(prescription)
			)
			next(`/${to.params.brandSlug}/login`)
			return false
		} else if (prescription && tabName === 'brand') {
			VueCookie.set(
				`${Cons[0].PATHS.NAME}PRESCRIPTION`,
				JSON.stringify(prescription)
			)
			next(`/${to.params.brandSlug}/login`)
			return false
		}
	}

	if (to.path !== '/preview' && !localStorage.getItem(APPCOOKIE)) {
		Store.dispatch('base/eventHit', {
			eventCategory:'/preview',
			eventAction:"guest login" +' - /preview - router',
			eventLabel:'guest login'
		})
		next()
		return false
	}

	if (VueCookie.get("os_type") === "ios" && !VueCookie.get('ios_app_version') ) {
		if( Store.state.user.info && Store.state.user.info.user_type == 'guest' ) {
			window.webkit.messageHandlers.onNativeCalled.postMessage({
				name: "authLogin",
				params: {}
			});
		}
	}

	if (to.path.startsWith(`/${to.params.brandSlug}/home`))
		Store.commit('setCurrentTab', 0, {root:1})

	if (to.path.startsWith(`/${to.params.brandSlug}/profile`) && to.query && to.query.section)
		to.meta.title = capitalizeFirstLetter(to.query.section)

	if (to.path.startsWith(`/${to.params.brandSlug}/resources`) && to.query && to.query['r-type'])
		to.meta.title = capitalizeFirstLetter(to.query['r-type'])
	
	if (to.path.startsWith(`/${to.params.brandSlug}/people`) && to.query && to.query.section)
		to.meta.title = capitalizeFirstLetter(to.query.section)
	
	if (to.path.startsWith(`'/${to.params.brandSlug}/group-type`) && to.params && to.params.groupType) {
		if (to.params.groupType == 'alliance')
			to.meta.title = 'Organizations'
		else if (to.params.groupType == 'interest')
			to.meta.title = 'Advocacies'
		else if (to.params.groupType == 'special_projects')
			to.meta.title = 'Special Projects'
		else if (to.params.groupType == 'event')
			to.meta.title = 'Events'
	}

	if (VueCookie.get(Cons[0].PATHS.NAME + 'MOBILE')) {
		let data = VueCookie.get(Cons[0].PATHS.NAME + 'MOBILE')
		let mobileView = JSON.parse(data)
		if ('type' in mobileView && mobileView.type === 'android') {
			Android.setMainTab(to.meta.mobileMain)
			Android.hideMainTab(to.meta.hideToolBar)
		} else if ('type' in mobileView && mobileView.type === 'ios') {
			window.webkit.messageHandlers.onNativeCalled.postMessage({
				name: 'tabToolbar',
				params: {
					tab: to.meta.mobileMain,
					hideToolBar: to.meta.hideToolBar
				}
			})
		}
	}

	setTabTitle(to.meta)
	next()
});

router.afterEach(route => {
	Store.commit('base/showDoActionModal', false);
	setTimeout(() => {
		document.body.scrollTop = 0
		document.documentElement.scrollTop = 0
	}, 333)
})

Vue.use(VueAnalytics, {
	id: 'UA-141670195-1',
	router,
	debug: {
		sendHitTask: process.env.NODE_ENV === 'production'
	}
})  

export default router;